import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  fetchSingleNews: ['postSlug', 'timeStamp'],
  fetchSingleNewsStart: null,
  fetchSingleNewsSuccess: ['singleNews'],
  fetchSingleNewsFailure: null,

  fetchRelatedArticlesForSingleNews: ['tagId', 'postId'],
  fetchRelatedArticlesForSingleNewsStart: null,
  fetchRelatedArticlesForSingleNewsSuccess: ['relatedArticles'],
  fetchRelatedArticlesForSingleNewsFailure: null
});

export { Types, Creators };
